<template>
  <div class="recipe-values-component">
    <ul class="items-list ">
      <li><span>OG</span> <span>{{recipe.og | sg }}</span></li>
      <li><span>FG</span> <span>{{recipe.fg | sg }}</span></li>
      <li><span>IBU</span> <span>{{recipe.ibu}}</span></li>
      <li><span>ABV</span> <span>{{recipe.abv | abv}}</span></li>
      <li><span>Color</span> <span>{{recipe.color}}</span></li>
    </ul>
  </div>
</template>

<script>
    export default {
        name: "recipe-values",
        props: {
            recipe: Object,
            type: String,
        },
        data() {
            return {};
        },
    };
</script>

<style scoped lang="scss">
  $outer-padding: 20px;

  .recipe-values-component {
    .items-list {
      list-style-type: none;
      padding: 0;
      margin: 0;

      li {
        span { white-space: nowrap; }
      }
    }


    .items-list {
      display: flex;

      li {
        display: block;
        padding: .5em;
        text-align: center;
        width: 20%;

        & > span:first-child {
          display: block;
          border-bottom: 3px solid var(--gray);
        }

      }
    }
  }
</style>
